import { EyeOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { Button, Form, Input } from "antd";
import { Card, Col, Collapse, List, Row } from "antd";
import { FC } from "react";

const { Panel } = Collapse;

type ViewUnlistedProcedureEchsProps = {
  enhancementsList: any;
  handleOpen: any;
  closeViewUnlistedProcedure: any;
  viewUnlistedProcedureEchs: boolean;
  isFetchingEnhancementData: boolean;
};

const ViewUnlistedProcedureEchs: FC<ViewUnlistedProcedureEchsProps> = (
  props,
) => {
  const calculateTotal = (data: any[]) => {
    return data?.reduce((sum: number, procedure: any) => {
      const amount = parseFloat(procedure?.unspecifiedProcedureAmount || "0");
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  return (
    <Modal
      loading={props?.isFetchingEnhancementData}
      title={
        <div>
          <span style={{ fontSize: "1rem", fontWeight: "600" }}>
            UNLISTED PROCEDURES
          </span>
        </div>
      }
      centered
      width={2000}
      open={props?.viewUnlistedProcedureEchs}
      onCancel={props?.closeViewUnlistedProcedure}
      footer={null}
      style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
      className="new-view-enhancement-ihx"
    >
      <List
        grid={{ gutter: 16, column: 1 }}
        dataSource={props?.enhancementsList}
        renderItem={(item: any, index) => (
          <List.Item>
            <Card
              className="enhancement-card"
              title={`Unlisted Procedure-${props?.enhancementsList?.length - index}`}
              style={{ cursor: "pointer", backgroundColor: "white" }}
            >
              <Collapse defaultActiveKey={["1"]}>
                <Panel header="Procedures" key="1">
                  <Form>
                    {item?.enhancementProceduresResponseList &&
                    item?.enhancementProceduresResponseList?.length > 0 ? (
                      item?.enhancementProceduresResponseList?.map(
                        (procedure: any) => (
                          <Row
                            key={procedure?.id}
                            gutter={[16, 16]}
                            align="top"
                            style={{
                              border: "1px solid #008B8B",
                              padding: "10px 20px",
                              borderRadius: "16px",
                              marginBottom: "0.8rem",
                              background: "white",
                              boxShadow: "0px 2px 8px 0px #00000040",
                            }}
                          >
                            <Col span={8}>
                              <Form.Item
                                label="Procedure"
                                name={"unspecifiedProcedureName"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={
                                    procedure?.unspecifiedProcedureName
                                  }
                                  disabled={true}
                                  style={{ color: "black" }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={7}>
                              <Form.Item
                                label="Diagnosis/Resaon"
                                name={"enhancementReason"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Diagnosis/Reason"
                                  disabled={true}
                                  defaultValue={procedure?.enhancementReason}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="Cost"
                                name={"unspecifiedProcedureAmount"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={
                                    procedure?.unspecifiedProcedureAmount
                                  }
                                  disabled={true}
                                  placeholder="Enter Cost"
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        ),
                      )
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        NO PROCEDURE
                      </div>
                    )}

                    {/* {item?.remarks && item?.remarks ? (
                      <div style={{ width: "100%", marginBottom: "0.8rem" }}>
                        <h4 style={{ display: "flex", justifyContent: "end" }}>
                          Remark: {item?.remarks}
                        </h4>
                      </div>
                    ) : (
                      <></>
                    )} */}

                    <Col span={8}>
                      <Form.Item
                        label="Remarks"
                        name={"remarks"}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <Input
                          disabled={true}
                          defaultValue={item?.remarks}
                          style={{ color: "black" }}
                        />
                      </Form.Item>
                    </Col>

                    {item?.enhancementProceduresResponseList &&
                    item?.enhancementProceduresResponseList?.length > 0 ? (
                      <div style={{ width: "100%", marginBottom: "0.8rem" }}>
                        <h4 style={{ display: "flex", justifyContent: "end" }}>
                          Total Amount: ₹{" "}
                          {calculateTotal(
                            item?.enhancementProceduresResponseList,
                          ) ?? 0}
                          /-
                        </h4>
                      </div>
                    ) : (
                      <></>
                    )}
                  </Form>
                </Panel>

                <Panel header="Documents" key="2">
                  {item?.enhancementDocuments &&
                  item?.enhancementDocuments?.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: 10,
                      }}
                    >
                      {item?.enhancementDocuments
                        ?.filter(
                          (doc: any) =>
                            doc?.documentLabelType?.toUpperCase()?.includes("UNLISTED"),
                        )
                        ?.map((doc: any) => (
                          <div
                            key={doc.id}
                            style={{
                              border: "1px solid #eee",
                              padding: 10,
                              borderRadius: 8,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>
                              {doc.documentLabelType || doc.documentName}
                            </span>
                            <Button
                              type="link"
                              icon={<EyeOutlined />}
                              onClick={() =>
                                props?.handleOpen(
                                  item?.enhancementDocuments,
                                  doc?.documentLabelType,
                                )
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      NO DOCUMENT UPLOADED
                    </div>
                  )}
                </Panel>
              </Collapse>
            </Card>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ViewUnlistedProcedureEchs;
